import styled from 'styled-components'

export const FormFillCheckButtons = styled.div`
  margin-bottom: 16px;
  width: 100%;
`
